module.exports = __webpack_public_path__ + "img/img-intj.2b8a8d7e.jpg";